import React, { useState } from 'react';

const CAT = [
  { value: 'insumos', label: 'Insumos' },
  { value: 'contas', label: 'Contas (luz, água)' },
  { value: 'transporte', label: 'Transporte' },
  { value: 'embalagens', label: 'Embalagens' },
  { value: 'outros', label: 'Outros' },
];

export default function CustoForm({ onSubmit, onCancel }) {
  const [descricao, setDescricao] = useState('');
  const [categoria, setCategoria] = useState('outros');
  const [valor, setValor] = useState('');
  const [data, setData] = useState(new Date().toISOString().split('T')[0]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!descricao.trim() || !valor) return;
    onSubmit({ descricao: descricao.trim(), categoria, valor: parseFloat(valor) || 0, data });
  };

  return (
    <form className="fm" onSubmit={handleSubmit}>
      <input className="inp" placeholder="Descrição *" value={descricao} onChange={e => setDescricao(e.target.value)} required />
      <select className="inp inp-sel" value={categoria} onChange={e => setCategoria(e.target.value)}>
        {CAT.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>
      <div className="inp-r">
        <input className="inp" type="number" step="0.01" placeholder="Valor R$ *" value={valor} onChange={e => setValor(e.target.value)} required />
        <input className="inp" type="date" value={data} onChange={e => setData(e.target.value)} />
      </div>
      <div className="btn-g">
        <button className="btn btn1" type="submit">Salvar</button>
        <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}
